module.exports = __webpack_public_path__ + "img/fixed_platform.66cfc677.svg";